import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { VersionStoreModel } from '@domain/metadata';

export const MetaDataActions = createActionGroup({
  source: 'META-DATA',
  events: {
    'Get version': emptyProps(),
    'Get version success': props<{ versions: VersionStoreModel }>(),
    'Get version fail': props<{ errorMsg: string }>(),
  },
});
